UserStorageService.$inject = ['$q', 'mx.SolutionBuilderAgent.Http'];
export function UserStorageService($q, http) {
	return {
		getData: getData,
		setData: setData,
		getValue: getValue,
		setValue: setValue,
	};

	function getData(keys) {
		if (!Array.isArray(keys)) {
			return $q.when({});
		}

		return http.get('api/userinfo/data?keys=' + encodeURIComponent(keys.join())).then(function (responseData) {
			var result = {};

			if (!responseData) {
				return result;
			}

			responseData.forEach(function (keyValuePair) {
				result[keyValuePair.Key] = keyValuePair.Value;
			});

			return result;
		});
	}

	function setData(data) {
		var requestData = {};
		var keys = Object.keys(data);

		keys.forEach(function (key) {
			var value = data[key];

			if (value !== undefined && value !== null) {
				if (typeof value === 'object') {
					requestData[key] = JSON.stringify(value);
				} else {
					requestData[key] = value.toString();
				}
			} else {
				requestData[key] = null;
			}
		});

		return http.post('api/userinfo/data', requestData);
	}

	function getValue(key) {
		return getData([key]).then(function (data) {
			return data[key];
		});
	}

	function setValue(key, value) {
		var data = {};
		data[key] = value;
		return setData(data);
	}
}
